module.exports = __webpack_public_path__ + "img/image60.953b5c8a.png";